export default "__VITE_ASSET__CTytIIQe__"